import type { ReactNode } from "react";

export default function MultiChartLayout({ children }: { children: ReactNode }) {
  return (
    <main className="legacy-light flex h-[calc(100vh-3.5rem)] w-full flex-col px-4 py-2">
      <h1 className="mb-2 shrink-0 text-xl font-semibold tracking-tight text-ink">
        Multi-Chart
      </h1>
      <div className="min-h-0 flex-1">{children}</div>
    </main>
  );
}
